import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Mixins, Prop } from 'vue-property-decorator';
import Course from '@/content/models/course.model';
import { CourseToolsMixin } from '@/courses/mixins/course-tools.mixin';
import { MULTIMEDIA_FILES_TYPES_EXT, _COURSE_STORE } from '@/courses/values/courses.values';
import { COURSE_EVENTS } from '@/content/values/events';
import { COURSES_EVENTS } from '@/courses/values/courses-events.values';


@Component({})
class EdFullScreen extends Mixins(CourseToolsMixin) {

  @Prop() readonly courseId: number;

  get zoomObject(): boolean {
    return this.$store.state.CourseStore.zoomObject;
  }

  get pdfLoading(): boolean {
    return this.$store.state.CourseStore.pdfLoading;
  }

  get course(): Course {
    return this.getCourseFromStore({ courseId: this.courseId })
  }

  get isSlide () {
    let isSlide = false;
    if(this.course) {
      if(this.course.viewer.sectionSelected) {
        isSlide = this.course.viewer.sectionSelected?.assetsInfo?.reduce( (directory, asset ) => asset.directory && asset.pdfUrl != null, true);
      } else if(this.course.viewer.projectSelected) {
        isSlide = this.course.viewer.projectSelected.section?.assetsInfo?.reduce( (directory, asset ) => asset.directory && asset.pdfUrl != null, true);
      }
    }
    return isSlide;
  }

  get isPresentationMode() : boolean{
    return this.$store.state.CourseStore.isPresentationTeacherMode || this.$store.state.CourseStore.isPresentationStudentMode;
  }

  activeFullScreen() {
    this.$edEventBus.$emit(COURSES_EVENTS.SLIDES_FULL_SCREEN);
  }

}
export default Vue.component('ed-full-screen', EdFullScreen);
